import React, { useState } from "react";
import { Rings } from 'react-loader-spinner';

const useFullPageLoader = () => {
    const [loading, setLoading] = useState(false);

    return [
        loading ?
            <div className="loading-container loading_FullPageLoader">
                <Rings
                    height="200"
                    width="200"
                    color="#01b5e5"
                    radius="6"
                    wrapperStyle={{
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "absolute"
                    }}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="rings-loading"
                />
                {/* <Vortex
                    visible={true}
                    height="150"
                    width="150"
                    ariaLabel="vortex-loading"
                    wrapperStyle={{}}
                    wrapperClass="vortex-wrapper"
                    colors={['#01b5e5', '#e41b12', '#88bd23', '#fab500', '#e6007e']}
                /> */}
            </div>
            : null,
        () => setLoading(true), //Show loader
        () => setLoading(false) //Hide Loader
    ];
};

export default useFullPageLoader;